import { render } from "./newCollegerejectedIEBC.vue?vue&type=template&id=53a53a50"
import script from "./newCollegerejectedIEBC.vue?vue&type=script&lang=js"
export * from "./newCollegerejectedIEBC.vue?vue&type=script&lang=js"

import exportComponent from "/mnt/extra-storage/2026_cdf/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__